import {createContext, useContext} from 'react';

import {collectEnumValues} from '../../../../libs/shared/core/src/models/api/types/enumTypes';
import {OnboardingTipTypesEnum} from '../../../models/api/preferencesModel';

/*
 * Props.
 */

export type InfoBubblesMap = {[key in OnboardingTipTypesEnum]?: boolean};

export interface InfoBubblesContextProps {
  /** A map of info bubble types and whether they are open. */
  infoBubbles: InfoBubblesMap;
  /** Handler to open an info bubble by type. */
  openInfoBubble: (arg: OnboardingTipTypesEnum) => void;
  /** Handler to close an info bubble by type. */
  closeInfoBubbles: (...bubbles: ReadonlyArray<OnboardingTipTypesEnum>) => void;
}

/*
 * Context.
 */

const initialInfoBubblesMap = Object.assign(
  {},
  ...collectEnumValues(OnboardingTipTypesEnum).map((e) => ({[e]: false})),
);

export const InfoBubblesContext = createContext<InfoBubblesContextProps>({
  infoBubbles: initialInfoBubblesMap,
  openInfoBubble: () => {},
  closeInfoBubbles: () => {},
});

/*
 * Hook.
 */

export function useInfoBubblesContext() {
  return useContext(InfoBubblesContext);
}
